import { Component } from 'react';
import Header from '../../../Header';
import MessageLink from '../../../MessageLink';
import Footer from '../../../Footer';
import ErrorBoundary from '../../../ErrorHandler/ErrorBoundary';
import InfoComponent from '../../InfoComponent';

class Missao extends Component {
	render() {
	  return (
		<div>
		 {/* HEADER */}{/* LOGIN */}
		<ErrorBoundary><Header /></ErrorBoundary>
		  <main>

			<InfoComponent image={"missao"} page={'missao'}></InfoComponent>		

			{/* Content page */}
			
		  </main>
		   {/* FOOTER */}
		   <ErrorBoundary><Footer />  </ErrorBoundary>
		   <ErrorBoundary><MessageLink/></ErrorBoundary>
		  {/* LGPD */}
		  <section className="_lgpd py-7">
			<div className="container">
			  <div className="row">
				<div className="col-md-8 mb-4 mb-md-0">
				  <p className="mb-0">
					A Forluz utiliza cookies e outras tecnologias semelhantes para melhorar a sua experiência, de acordo com a nossa Política de Privacidade e, ao continuar navegando, você concorda com estas condições.
				  </p>
				</div>
				<div className="col-md-4  offset-xl-1 col-xl-3">
				  <a href="#" className="btn btn-primary btn-100 rounded d-block btn-lgpd"> Aceitar </a>
				</div>
			  </div>
			</div>
		  </section>		 
		</div>
	  );
	}
  };

  export default Missao;